import store from './store/index.js'
import { createRouter, createWebHistory } from "vue-router";

// import HomePage from "./components/pages/durraHome";
import HomePage from "./components/pages/NewHome.vue";

import forgotPassword from "./components/pages/ForgotPassword.vue";
import resetPassword from "./components/pages/resetPassword.vue";




import Login from "./components/pages/login.vue";
import loanClients from "./components/pages/loanClients.vue";

import activateAccount from "./components/pages/activateAccount.vue";

import Signup from "./components/pages/RegisterUser.vue";
import DashboardPage from "./components/pages/newDashboard.vue";






import userRegistration from "./components/pages/NewRegistration.vue";


import createLoanclient from './components/pages/createLoanclient.vue';

import newLoan from './components/pages/newLoan.vue';
import allLoans from './components/pages/allLoans.vue';
import LoanPayments from './components/pages/LoanPayments.vue';
import LoansDashboard from './components/pages/loandashboard.vue';

import investorDashboard from './components/pages/investorDashboard.vue';
import ReceiveLoanpayment from './components/pages/receiveLoanpayment.vue';








// import allTrades from "./components/pages/allTrades.vue"
















const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
   
        { path: "/create/loan/client", component: createLoanclient },

    { path: "/forgot/password", component: forgotPassword },
    { path: "/reset/password/:token", component: resetPassword },


    
    { path: "/activate", component: activateAccount },
 

  
   
    { path: "/user/registration/", component: userRegistration },
    { path: "/login/", component: Login },
    { path: "/signup/", component: Signup },
    { path: "/loan/clients/", component: loanClients, meta: {
      requiresAuth: true
    } },

        { path: "/receive/loan/payment/", component: ReceiveLoanpayment, meta: {
      requiresAuth: true
    } },


       { path: "/investor/dashboard/", component: investorDashboard, meta: {
      requiresAuth: true
    } },

      { path: "/all/loans/", component: allLoans, meta: {
      requiresAuth: true
    } },
       { path: "/loans/dashboard/", component: LoansDashboard, meta: {
      requiresAuth: true
    } },


     { path: "/new/loan/", component: newLoan, meta: {
      requiresAuth: true
    } },

       { path: "/dashboard/", component: DashboardPage, meta: {
      requiresAuth: true
    } },
       { path: "/loan/payments/", component: LoanPayments, meta: {
      requiresAuth: true
    } },



 



    


    // {path: "/dashboard", component:DashBoard, meta: {
    //   requiresAuth: true
    // }},



    
   
    

  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
   
    if (!store.getters.isLoggedIn) {
      next({ path: '/login' })
    } else {
      next() 
    }
    // console.log(`Navigating to: ${to.fullPath}`);

  } else {
    // console.log(`Navigating to: ${to.fullPath}`);
    next() 
  }
})

export default router;
